const { FormControlLabel } = require("@mui/material");
const { styled } = require("@mui/styles");

export const StyledFormControlLabel = styled(FormControlLabel)({
  color: "#A7A7A7",
  "& .MuiFormControlLabel-label": {
    fontSize: 14,
  },
});
